import { render } from "./ATAIndividualReport.vue?vue&type=template&id=3c198612"
import script from "./ATAIndividualReport.vue?vue&type=script&lang=js"
export * from "./ATAIndividualReport.vue?vue&type=script&lang=js"

import "./ATAIndividualReport.vue?vue&type=style&index=0&id=3c198612&lang=css"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__